const fireEvent = (eventName, data = {}) => {
  window.dispatchEvent(new CustomEvent(eventName, data))
}

export default fireEvent
